/*
 * This file is generated by icons/template.js
 */
const SvgCircle = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}>
		<path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2z" />
	</svg>
);
SvgCircle.displayName = 'iconCircle';
export default SvgCircle;
